import { ChangeEvent, useEffect, useState } from "react";
import Title from "../../ui/Title";
import dayjs, { Dayjs } from "dayjs";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Grid,
  Input,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Stack,
  Typography,
} from "@mui/material";
import { StyledInput } from "../../ui/StyledInput";
import { Card } from "../../ui/Card";
// import TextField from "@mui/material/TextField";
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import styled from "styled-components";
import { ReturnsFormType } from "./AddReturns";
import { StyledButton } from "../../ui/StyledButton";

const returnReasonFilter = [
  {
    label: " Item is damaged ",
  },
  {
    label: " Received wrong item ",
  },
  {
    label: " Parcel damaged on arrival ",
  },
  {
    label: " Quality not as expected ",
  },
  {
    label: " Missing Item or accessories ",
  },
];

const ReturnsDetailsForm = ({
  label,
  handleNext,
  handleBack,
  finalForm,
  setFinalForm,
}: {
  label: string;
  handleNext: () => void;
  handleBack: () => void;
  setFinalForm: (finalForm: any) => void;
  finalForm: ReturnsFormType;
}) => {
  const currentDate = dayjs();

  const [date] = useState<Dayjs | null>(currentDate);
  const [returnProductTag, setReturnProductTag] = useState<boolean>(false);
  const [product, setProduct] = useState([{ productPlus: false }]);

  const handleAddProduct = () => {
    setProduct([...product, { productPlus: false }]);
  };

  const addProductHandler = (index: number) => {
    const updatedProducts = [...product];
    updatedProducts[index] = {
      ...updatedProducts[index],
      productPlus: !updatedProducts[index].productPlus,
    };
    setProduct(updatedProducts);
  };
  const onlyNumber = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    limit: number
  ) => event.target.value.replace(/[^0-9]/g, "").slice(0, limit);

  const handleNumberChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string
  ) => {
    event.target.value = onlyNumber(event, 10);
    handleInputChange(event, field);
  };

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string
  ) => {
    const newFormData = { ...finalForm };
    newFormData[field] = e.target.value;
    setFinalForm(newFormData);
  };

  const handleSelectChange = (e: SelectChangeEvent<string>) => {
    const newFormData = { ...finalForm };
    let type = e.target.value;
    newFormData.freight_on_carrier = type;
    setFinalForm(newFormData);
  };

  const [isCod, setIsCode] = useState<boolean>(false);

  const handleBooleanChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string
  ) => {
    const newFormData = { ...finalForm };
    let type = e.target.value;
    if (type === "true") {
      newFormData[field] = true;
      setIsCode(true);
    } else {
      newFormData[field] = false;
      setIsCode(false);
    }
    setFinalForm(newFormData);
  };

  const [canNext, setCanNext] = useState(true);

  const validateForm = () => {
    let canNext = true;

    if (
      // finalForm.ewaybill_number.trim() !== "" &&
      // finalForm.invoice_number.trim() !== "" &&
      finalForm.invoice_value.trim() !== ""
      // finalForm.order_id.trim() !== ""
    ) {
      canNext = false;
    }

    if (isCod) {
      canNext = true;
      if (finalForm.cod_amount.trim() !== "") {
        canNext = false;
      }
    }

    setCanNext(canNext);
  };

  useEffect(() => {
    validateForm();
  }, [finalForm, isCod]);
  return (
    <Box>
      <Title title={`Add ${label}`} />
      <Box
        sx={{
          margin: "10px 0",
        }}
      >
        <Box>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <FormLabel>
                <Typography fontSize={12}>
                  Return ID (Auto Generated)
                </Typography>
              </FormLabel>
              <StyledInput
                value={finalForm.order_id}
                onChange={(e) => handleInputChange(e, "order_id")}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormLabel>
                <Typography fontSize={12}>Invoice Value</Typography>
              </FormLabel>
              <StyledInput
                placeholder="Invoice Value"
                value={finalForm.invoice_value}
                onChange={(e) => handleNumberChange(e, "invoice_value")}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormLabel>
                <Typography fontSize={12}>Invoice Number</Typography>
              </FormLabel>
              <StyledInput
                placeholder="Invoice Number"
                value={finalForm.invoice_number}
                onChange={(e) => handleInputChange(e, "invoice_number")}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormLabel>
                <Typography fontSize={12}>Ewaybill Number</Typography>
              </FormLabel>
              <StyledInput
                placeholder="Ewaybil Number"
                value={finalForm.ewaybill_number}
                onChange={(e) => handleInputChange(e, "ewaybill_number")}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl sx={{ minWidth: 150 }} size="small">
                <FormLabel>
                  <Typography fontSize={12}>Insurance</Typography>
                </FormLabel>
                <Select
                  value={finalForm.freight_on_carrier}
                  onChange={(e) => handleSelectChange(e)}
                >
                  <MenuItem value={"NI"}>No Issurance</MenuItem>
                  <MenuItem value={"CI"}>Carrier Issurance</MenuItem>
                  <MenuItem value={"OI"}>Own Issurance</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Typography>Payment Details</Typography>
              <Typography fontSize={10}>
                Select mode of payment that your buyer has chosen for the order
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <RadioGroup
                value={finalForm.cod}
                name="radio-buttons-group"
                onChange={(e) => handleBooleanChange(e, "cod")}
              >
                <Stack direction={"row"}>
                  <Stack
                    direction={"row"}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <Radio value={false} size="small" />
                    <Typography fontSize={12}>Prepaid</Typography>
                  </Stack>
                  <Stack
                    direction={"row"}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <Radio value={true} size="small" />
                    <Typography fontSize={12}>Cash on Delivery</Typography>
                  </Stack>
                </Stack>
              </RadioGroup>
            </Grid>
            <Grid item xs={12}>
              {isCod && (
                <Grid item xs={12} sm={6} md={3}>
                  <FormLabel>
                    <Typography fontSize={12}>Cod Amount</Typography>
                  </FormLabel>
                  <StyledInput
                    placeholder="Cod Amount"
                    value={finalForm.cod_amount}
                    onChange={(e) => handleNumberChange(e, "cod_amount")}
                    fullWidth
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Stack
        flexDirection={"row"}
        justifyContent={"flex-end"}
        alignItems={"center"}
        marginTop={2}
        columnGap={2}
      >
        <StyledButton variant="outlined" onClick={handleBack}>
          Back
        </StyledButton>
        <StyledButton
          disabled={canNext}
          variant="contained"
          onClick={handleNext}
        >
          Next
        </StyledButton>
      </Stack>
    </Box>
  );
};

export default ReturnsDetailsForm;
